import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNpday75 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_75: Record<
  Exclude<PageIdWoofzNpday75, PageIdWoofzNpday75.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NPDAY_75]: {
    id: PageId.SUBSCRIPTIONS_NPDAY_75,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_NPDAY_75]: {
    id: PageId.CHAT_UPSELL_NPDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NPDAY_75]: {
    id: PageId.UPSELL_NPDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NPDAY_75]: {
    id: PageId.DOWNLOAD_NPDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
